// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"5a19a68d","198":"53004b89","261":"0ef63586","331":"d78d013c","498":"b5b10718","703":"76a51d7e","787":"9cbf2a4e","813":"76db42e8","936":"627684d2","989":"53cee567"}[chunkId] + ".chunk.js";
};